<div class="row mb-3">
  <div class="col fw-regular">
    {{ label }}
  </div>
  @if (editMode && !supplyChainActorEditMode) {
    <div class="col-auto">
      <button type="button" class="btn btn-plain btn-outline-danger border-0 p-1 h-100"
              style="box-shadow: none !important; width: 32px" (click)="deleteActor()">
        <i class="text-danger fa fa-fw fa-light fa-trash-can"></i>
      </button>
    </div>
  }
</div>
@if (supplyChainActor) {
  @if (supplyChainActor) {
    <div class="card form-group">
      <div class="card-body p-4">
        <div class="row mb-3">
          <div class="col d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="EORI number" [includeMargin]="false"
                            [(value)]="supplyChainActor.identificationNumber"
                            [editMode]="editMode && supplyChainActorEditMode"
                            [checkForErrors]="true">
              <input class="input-group form-control" [(ngModel)]="supplyChainActor.identificationNumber" required/>
            </app-form-field>
          </div>
          <div class="col d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Type" [includeMargin]="false" [(value)]="supplyChainActor.type"
                            [editMode]="editMode && supplyChainActorEditMode"
                            [formatter]="utils.supplyChainTypeFormatter">
              <app-search [(ngModel)]="supplyChainActor.type" [options]="utils.additionalSupplyChainTypes"
                          [inputFormatter]="utils.supplyChainTypeFormatter" required></app-search>
            </app-form-field>
          </div>
        </div>
        @if (editMode && supplyChainActorEditMode) {
          <div class="row mt-3">
            <div class="col-auto ms-auto">
              <button type="button" class="btn btn-outline-secondary" aria-label="Cancel" (click)="cancel()">Cancel
              </button>
            </div>
            <div class="col-auto">
              <button type="button" class="btn btn-primary" (click)="save()">Save</button>
            </div>
          </div>
        }
        @if (editMode && !supplyChainActorEditMode) {
          <div class="position-absolute end-0 top-0 me-2 mt-2">
            <button type="button" class="btn btn-tertiary p-1" (click)="toggleEditMode()">
              <i class="fa fa-fw fa-light fa-pencil"></i>
            </button>
          </div>
        }
      </div>
    </div>
  }
}
